<template>
    <div class="loader"></div>
</template>

<script lang="ts" setup>
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.loader {
    border: 16px solid var(--spinner-border-color);
    /* Light grey */
    border-top: 16px solid var(--dateit-primary);
    /* Blue */
    border-radius: 50%;
    width: 80px;
    height: 80px;
    animation: spin 1s linear infinite;
    margin-left: auto;
    margin-right: auto;
    margin-top: 50px;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}
</style>
